import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    localStorage.setItem('analytics-consent', 'accepted');
    setShowConsent(false);
    // Trigger custom event for GA initialization if needed
    window.dispatchEvent(new CustomEvent('cookieConsentAccepted'));
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    localStorage.setItem('analytics-consent', 'declined');
    setShowConsent(false);
    // Trigger custom event for GA opt-out
    window.dispatchEvent(new CustomEvent('cookieConsentDeclined'));
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-sm border-t shadow-lg">
      <div className="max-w-7xl mx-auto p-4">
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <h3 className="font-normal text-foreground mb-2">Cookie Notice</h3>
            <p className="text-sm text-muted-foreground mb-3">
              We use cookies to enhance your experience and analyze site usage with Google Analytics. 
              Analytics cookies help us understand how visitors interact with our site to improve functionality. 
              Essential cookies are always enabled. If you choose "Essential Only," we may still collect 
              basic anonymized, cookieless usage data (e.g., page visit counts) with no personal information stored. 
              You can manage your cookie preferences at any time.
            </p>
            <div className="flex gap-2">
              <Button onClick={acceptCookies} size="sm" variant="accent">
                Accept All Cookies
              </Button>
              <Button onClick={declineCookies} variant="outline" size="sm">
                Essential Only
              </Button>
            </div>
          </div>
          <Button
            onClick={declineCookies}
            variant="ghost"
            size="sm"
            className="shrink-0"
            aria-label="Close cookie notice"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};